import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const ClassesXItoXII = () => {
  useEffect(() => {
    document.title = "Classes XI - XII -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Classes XI - XII</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="syl">
                {" "}
                Syllabus 2026-2027{" "}
                <span> {/*Syllabus will be updated shortly */}</span>
              </h1>

              {/* <h5 className="head">    Syllabus 2024-2025</h5> */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h6>Class XII</h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIAccountancy.pdf"
                    target="_blank">
                    Accountancy{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIbio.pdf"
                    target="_blank"
                  >
                    Biology{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIBusinessStudies.pdf"
                    target="_blank"
                  >
                    Business Studies{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIche.pdf"
                    target="_blank"
                  >
                    Chemistry{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIcomSci.pdf"
                    target="_blank"
                  >
                    {" "}
                    Computer Science{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIECO.pdf"
                    target="_blank"
                  >
                    Economics{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIEng.pdf"
                    target="_blank"
                  >
                    {" "}
                    English{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIGeo-1.pdf"
                    target="_blank"
                  >
                    Geography{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIHomeSci.pdf"
                    target="_blank"
                  >
                    Home Science{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIPoliSci.pdf"
                    target="_blank"
                  >
                    Political Science{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIMath.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIPhy-1.pdf"
                    target="_blank"
                  >
                    Physics{" "}
                  </Link>
                </li>




                <li>
                  <Link
                    to="#"
                  >
                    History{" "}
                  </Link>
                </li>

                <li>
                  <Link
                    to="#"
                  >
                    Ip{" "}
                  </Link>
                </li>


                <li>
                  <Link
                    to="#"
                  >
                    {" "}
                    Psychology{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                  >
                    {" "}
                    Physical Education{" "}
                  </Link>
                </li>
                {/* 
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIHis-1.pdf"
                    target="_blank"
                  >
                    History{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIIP.pdf"
                    target="_blank"
                  >
                    Ip{" "}
                  </Link>
                </li>
          
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIPsy.pdf"
                    target="_blank"
                  >
                    {" "}
                    Psychology{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIphyedu.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physical Education{" "}
                  </Link>
                </li>

                */}

              </ul>

              <h6>Classes XI </h6>
              <ul className="list mainlist">

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIbio.pdf"
                    target="_blank"
                  >
                    {" "}
                    Biology
                  </Link>{" "}
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIacc.pdf"
                    target="_blank"
                  >
                    {" "}
                    Accountancy{" "}
                  </Link>{" "}
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIBusinessStudies.pdf"
                    target="_blank"
                  >
                    Business Studies{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIche.pdf"
                    target="_blank"
                  >
                    Chemistry{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIcomsci.pdf"
                    target="_blank"
                  >
                    {" "}
                    Computer Science
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIeco.pdf"
                    target="_blank"
                  >
                    Economics{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIeng.pdf"
                    target="_blank"
                  >
                    {" "}
                    English
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIHomeSci.pdf"
                    target="_blank"
                  >
                    Home Science
                  </Link>{" "}
                </li>


                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXImath.pdf"
                    target="_blank"
                  >
                    {" "}
                    Maths{" "}
                  </Link>{" "}
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIphy-1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physics
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIpoliseci-1.pdf"
                    target="_blank"
                  >
                    Political Science{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIpsy.pdf"
                    target="_blank"
                  >
                    {" "}
                    Psychology
                  </Link>{" "}
                </li>

                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIgeo.pdf"
                    target="_blank"
                  >
                    Geography{" "}
                  </Link>{" "}
                </li> 
                <li>
                  <Link
                    to="#"  >
                    {" "}
                    History
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="#"  >
                    Ip
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="#"  >
                    Statistics
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="#"  >
                    {" "}
                    Physical Education{" "}
                  </Link>
                </li>
                {/*
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIhis.pdf"
                    target="_blank"
                  >
                    {" "}
                    History
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIIp.pdf"
                    target="_blank"
                  >
                    Ip
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIstatics.pdf"
                    target="_blank"
                  >
                    Statistics
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classXIphyedu.pdf"
                    target="_blank"
                  >
                    {" "}
                    Physical Education{" "}
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassesXItoXII;
